/*eslint-disable*/
import React, { Component } from 'react'
import TitleBar from '../../components/titleBar/title_bar'
import CheckListTable from '../../components/checklistComponent/checklistTable'

export default class Checklist extends Component {
    render() {
        return (
            <React.Fragment>
                <CheckListTable {...this.props} />
            </React.Fragment>
        )
    }
}
